import Vue from 'vue'

export const state = {
  pageLoadingStatus: 'initial', // => "loading" => "loaded" || "error"
  paymentProcessStatus: 'initial', // => "processing" => "processed" || "failed"
  showLocationModal: false,
  showTransactionModal: false,
}

export const getters = {
  pageLoadingStatus: (state) => {
    return state.pageLoadingStatus
  },
  paymentProcessStatus: (state) => {
    return state.paymentProcessStatus
  },
  showLocationModal: (state) => {
    return state.showLocationModal
  },
  showTransactionModal: (state) => {
    return state.showTransactionModal
  },
}

export const mutations = {
  setPageLoadingStatus(state, status) {
    state.pageLoadingStatus = status
  },
  setPaymentProcessStatus(state, status) {
    state.paymentProcessStatus = status
  },
  toggleLocationModal(state, { modalIsVisible }) {
    state.showLocationModal = modalIsVisible
  },
  toggleTransactionModal(state, { modalIsVisible }) {
    state.showTransactionModal = modalIsVisible
  },
}

export const actions = {
  setPageLoadingStatus({ commit }, status) {
    commit('setPageLoadingStatus', status)
  },
  setPaymentProcessStatus({ commit }, status) {
    commit('setPaymentProcessStatus', status)
  },
  // eslint-disable-next-line no-empty-pattern
  showToast({}, { toastMessage, limit }) {
    if (!limit || Vue.toasted.toasts.length < 1) {
      Vue.toasted.show(toastMessage, {
        theme: 'primary',
        className: 'default-toast',
        closeOnSwipe: true,
        duration: 5000,
        fullWidth: true,
        fitToScreen: true,
        position: 'bottom-center',
        singleton: true,
        action: [
          {
            text: '',
            class: 'toast__icon',
            onClick: (e, toastObject) => {
              toastObject.goAway(0)
            },
          },
        ],
      })
    }
  },
  toggleLocationModal({ commit }, { modalIsVisible }) {
    commit('toggleLocationModal', { modalIsVisible })
  },
  toggleTransactionModal({ commit }, { modalIsVisible }) {
    commit('toggleTransactionModal', { modalIsVisible })
  },
}
